import type { JanusJS } from 'lib/janus';

export interface CandidateStats {
  startTime: number;
  gathered: number;
  nonHostGathered: number;
  connectionEstablished: boolean;
  connectionTime: number | null;
  candidateErrors: JanusJS.IceCandidateError[];
}

// Connection timing resets only when the restart begins from a live connection, so
// previouslyConnected keeps the PC's history across a restart that follows an ICE drop.
export const nextCandidateGeneration = (
  stats: CandidateStats,
  now = Date.now()
): CandidateStats => ({
  ...stats,
  startTime: now,
  gathered: 0,
  nonHostGathered: 0,
  candidateErrors: [],
  ...(stats.connectionEstablished ? { connectionEstablished: false, connectionTime: null } : {}),
});

// Firefox ends a gathering with an empty-string candidate before the null one; it is not a
// candidate. Non-host candidates (srflx/relay/prflx) prove STUN/TURN was reachable.
export const countCandidate = (
  stats: CandidateStats,
  candidate: Pick<RTCIceCandidate, 'candidate' | 'type'>
): CandidateStats => {
  if (!candidate.candidate) {
    return stats;
  }

  return {
    ...stats,
    gathered: stats.gathered + 1,
    nonHostGathered:
      candidate.type && candidate.type !== 'host'
        ? stats.nonHostGathered + 1
        : stats.nonHostGathered,
  };
};
